import type { SlashItem } from './slashTypes';

const getSlashItemMatchRank = (item: SlashItem, normalizedQuery: string) => {
  const title = item.title.toLowerCase();
  if (title === normalizedQuery) return 0;
  if (title.startsWith(normalizedQuery)) return 1;
  if (title.includes(normalizedQuery)) return 2;

  const normalizedKeywords = (item.keywords ?? []).map(keyword => keyword.toLowerCase());
  if (normalizedKeywords.some(keyword => keyword === normalizedQuery)) return 3;
  if (normalizedKeywords.some(keyword => keyword.startsWith(normalizedQuery))) return 4;
  if (normalizedKeywords.some(keyword => keyword.includes(normalizedQuery))) return 5;

  return Number.POSITIVE_INFINITY;
};

export const filterSlashItems = (items: SlashItem[], query: string) => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return items;

  return items
    .map((item, index) => ({
      item,
      index,
      rank: getSlashItemMatchRank(item, normalizedQuery),
    }))
    .filter(entry => Number.isFinite(entry.rank))
    .sort((a, b) => a.rank - b.rank || a.index - b.index)
    .map(entry => entry.item);
};
